import PropTypes from 'prop-types';
import { useFormContext } from './context';
const {
  Checkbox,
  ControlGroup
} = svs.ui.reactForm;
const FormConsentCheckbox = ({
  id = 'consent',
  isDisabled = false
}) => {
  const {
    formData,
    formErrors,
    updateField
  } = useFormContext();
  const hasError = Boolean(formErrors[id]);
  const errorMessage = formErrors[id];
  const handleChange = event => {
    updateField(id, event.target.checked);
  };
  return <ControlGroup errorMessage={errorMessage} hasError={hasError} v2>
      <label className="u-flex u-align-items-start" style={{
      textTransform: 'none',
      fontFamily: 'inherit',
      fontWeight: 'normal'
    }}>
        <Checkbox checked={formData?.[id] || false} disabled={isDisabled} id={id} onChange={handleChange} required />
        <span className="padding-left-2">
          Jag är medveten om att AB Svenska Spel gör en sedvanlig kreditprövning
          och att säkerhet kan komma att krävas.
          <br />
          <span className="text-color">
            Jag har tagit del av Svenska Spels information om behandling av
          </span>
          {' '}
          <a href="https://om.svenskaspel.se/om-oss/ombud-partner/personuppgifter/" rel="noreferrer" target="_blank">
            personuppgifter
          </a>
          {' '}
          <span className="text-color">*</span>
        </span>
      </label>
    </ControlGroup>;
};
FormConsentCheckbox.propTypes = {
  id: PropTypes.string,
  isDisabled: PropTypes.bool
};
export default FormConsentCheckbox;